import React from 'react';
import { Routes, Route } from 'react-router-dom';
import CustomersListPage from './CustomersListPage';

export default function CustomersRoutes() {
  return (
    <Routes>
      <Route index element={<CustomersListPage />} />
    </Routes>
  );
}
